import { api } from "@/frontend/services/api";
import type {
  ApiResponse,
  BettingPoolResponseDTO,
  BettingPoolWithTournamentResponseDTO,
  CreateBettingPoolRequestDTO,
  UpdateBettingPoolRequestDTO,
  UpdateBettingPoolIsJoinableRequestDTO,
  UpdateBettingPoolIsPredictableRequestDTO,
  ChangePoolStatusRequestDTO,
  BettingPoolsPaginatedResponseDTO,
  BettingPoolsWithDetailsPaginatedResponseDTO,
  PaginationRequestDTO,
  PoolLeaderboardEntryDTO,
  PoolLeaderboardQueryDTO,
} from "@/shared/dto";

const BASE_URL = "/betting-pools/private";

export const bettingPoolService = {
  getPaginate: (params?: PaginationRequestDTO) =>
    api.getWithParams<ApiResponse<BettingPoolsPaginatedResponseDTO>>(BASE_URL, params),
  getMyPools: (params?: PaginationRequestDTO) =>
    api.getWithParams<ApiResponse<BettingPoolsWithDetailsPaginatedResponseDTO>>(`${BASE_URL}/my-pools`, params),
  getJoinedPools: (params?: PaginationRequestDTO) =>
    api.getWithParams<ApiResponse<BettingPoolsWithDetailsPaginatedResponseDTO>>(`${BASE_URL}/joined-pools`, params),
  getById: (id?: string) =>
    api.get<ApiResponse<BettingPoolResponseDTO>>(`${BASE_URL}/${id}`),
  getByIdWithTournament: (id?: string) =>
    api.get<ApiResponse<BettingPoolWithTournamentResponseDTO>>(`${BASE_URL}/${id}/details`),
  create: (data: CreateBettingPoolRequestDTO) =>
    api.post<ApiResponse<BettingPoolResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdateBettingPoolRequestDTO) =>
    api.put<ApiResponse<BettingPoolWithTournamentResponseDTO>>(`${BASE_URL}/${id}`, data),
  updateIsJoinable: (id: string, data: UpdateBettingPoolIsJoinableRequestDTO) =>
    api.patch<ApiResponse<void>>(`${BASE_URL}/${id}/joinable`, data),
  updateIsPredictable: (id: string, data: UpdateBettingPoolIsPredictableRequestDTO) =>
    api.patch<ApiResponse<void>>(`${BASE_URL}/${id}/predictable`, data),
  updateStatus: (id: string, data: ChangePoolStatusRequestDTO) =>
    api.patch<ApiResponse<void>>(`${BASE_URL}/${id}/status`, data),
  delete: (id: string) => api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
  getLeaderboard: (id: string, params?: PoolLeaderboardQueryDTO) =>
    api.getWithParams<ApiResponse<PoolLeaderboardEntryDTO[]>>(`${BASE_URL}/${id}/leaderboard`, params),
};
